import { getContext, track } from '../core';

declare global {
  interface Window {
    Intercom?: (command: string, ...args: unknown[]) => void;
  }
}

export function initIntercomTracking(): void {
  const tryAttach = () => {
    if (typeof window.Intercom === 'function') {
      window.Intercom('onConversationInitiated', () => {
        const ctx = getContext();
        track('live_chat_demo_request', {
          page_name: ctx.page_title,
        });
      });
      return true;
    }
    return false;
  };

  // Intercom may load asynchronously — retry for up to 10 seconds
  if (tryAttach()) return;

  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    if (tryAttach() || attempts >= 20) {
      clearInterval(interval);
    }
  }, 500);
}
